<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>用车分配</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form
        :inline="true"
        :model="searchFrom"
        ref="searchFrom"
        class="demo-form-inline"
        label-width="90px"
        size="mini"
      >
        <div class="inpBox">
          <el-form-item label="创建日期:" prop="deliveryDate">
            <el-date-picker
              v-model="searchFrom.startDate"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="datetime"
            ></el-date-picker>&nbsp;-&nbsp;&nbsp;
            <el-date-picker
              v-model="searchFrom.endDate"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="datetime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="用车部门:" prop="departmentCode">
            <el-select v-model="searchFrom.departmentCode" placeholder="请选择" @change="carUnitChange(searchFrom.departmentCode)">
              <el-option
                v-for="item in carUnitOptions"
                :key="item.orgCode"
                :label="item.orgName"
                :value="item.orgCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用车单位:" prop="subsidiaryDepartmentCode">
            <el-select v-model="searchFrom.subsidiaryDepartmentCode" @change="carAreaChange()" placeholder="请选择">
              <el-option
                v-for="item in carAreaOptions"
                :key="item.orgCode"
                :label="item.orgName"
                :value="item.orgCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工作类型:" prop="workType">
            <el-select v-model="searchFrom.workType" placeholder="请选择">
              <el-option
                v-for="(item, index) in jobTypeOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车型:" prop="vhcTypeId">
            <el-select v-model="searchFrom.vhcTypeId" filterable placeholder="请选择">
              <!-- <el-option
                v-for="(item, index) in carTypeOptions"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option> -->
              <el-option
                v-for="item in carTypeOptions"
                :key="item.vhcTypeId"
                :label="item.vhcTypeName"
                :value="item.vhcTypeId">
              </el-option>
            </el-select>
          </el-form-item>

        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode="00MP003B001" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode="00MP003B002" v-if="btnFlg[1]">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableList"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%; margin-top: 10px"
        center
        @row-click="handleRowClick"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }"
        highlight-current-row
      >
        <!-- <el-table-column type="selection" width="55" align="center" ></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="customerName" label="操作" width="150" align="center" >
          <template slot-scope="scope"><div>
            <el-button @click="distributionClick(scope.row)" type="text" size="small" btnCode="00MP003B003" v-if="scope.row.applyFlg == '1' && btnFlg[2]">分配</el-button>
            <el-button @click="changeDataClick(scope.row)" type="text" size="small" btnCode="00MP003B004" v-if="scope.row.applyFlg == '2'  && btnFlg[3]">修改</el-button>
            <el-button @click="detailsClick(scope.row)" type="text" size="small"  btnCode="00MP003B005" v-if="btnFlg[4] && (scope.row.applyFlg == '2' || scope.row.applyFlg == '3')">详情</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="applyNo" label="申请单号" align="center" width="230"></el-table-column>
        <el-table-column prop="statusShow" label="状态" align="center" width="100" ></el-table-column>
        <el-table-column prop="departmentName" label="用车部门" align="center" width="180" ></el-table-column>
        <el-table-column prop="subsidiaryDepartmentName" label="用车单位" align="center" width="130" ></el-table-column>
        <el-table-column prop="fleetNameShow" label="分配车队" align="center" width="150" ></el-table-column>
        <el-table-column prop="vhcTypeName" label="车型" align="center" width="120" ></el-table-column>
        <el-table-column prop="tonnageModel" label="吨位" align="center" width="100" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="vhcNum" label="车数" align="center" width="100" ></el-table-column>
        <el-table-column prop="price" label="单价" align="center" width="150" ></el-table-column>
        <el-table-column prop="workType" label="工作类型" align="center" width="100" ></el-table-column>
        <el-table-column prop="workContent" label="工作内容" align="center" width="180" ></el-table-column>
        <el-table-column prop="applyTimeShow" label="用车时间" align="center" width="350" ></el-table-column>
        <el-table-column prop="applyUser" label="用车人" align="center" width="100"></el-table-column>
        <el-table-column prop="userMobile" label="联系电话" align="center" width="120" ></el-table-column>
        <el-table-column prop="vhcapplyAddress" label="工作地点" align="center" width="180" ></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="createUserName" label="创建人" align="center" ></el-table-column>
        <el-table-column prop="createTimeShow" label="创建时间" align="center" width="180" ></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 分配/修改 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="addAndChangeMark"
    @close="closeDialog()"
    width="600px"
    center>
      <div v-loading='addAndChangeLoading'>
      <div class="bigBox">
        <div>可用车数：</div>
        <div class="tongJi">
          <el-table
            :data="addAndChangeFrom.addAndChangeFromTabList"
            ref=""
            border
            bordersize="mini"
            style="width: 100%; margin-top: 10px"
            center
            :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            :header-row-style="{ height: '45px' }"
            :row-style="{ height: '35px' }"
            highlight-current-row
          >
            <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
            <el-table-column prop="fleetName" label="车队" align="center"></el-table-column>
            <el-table-column prop="count" label="可用车数" align="center"></el-table-column>
          </el-table>
        </div>
        <div style="display: flex;width:99%;justify-content: space-between;">
          <div>车队分配：</div>
          <div style="margin-top:-5px;">
            <el-button  type="primary" @click="addFleetTab()" size="mini">新增</el-button>
          </div>
        </div>
        <div class="tongJi">
          <el-table
            :data="addAndChangeFrom.fleetTabList"
            ref=""
            border
            bordersize="mini"
            style="width: 100%; margin-top: 10px"
            center
            :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            :header-row-style="{ height: '45px' }"
            :row-style="{ height: '35px' }"
            highlight-current-row
          >
            <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
            <el-table-column prop="fleetCode" label="车队" align="center" width="230">
              <template slot-scope="scope"><div>
                <el-select v-model="scope.row.fleetCode" :disabled='scope.row.fleetDisabled' placeholder="请选择" size="mini" style="width:200px;">
                  <el-option
                    v-for="(item,index) in fleetOptions"
                    :key="index"
                    :label="item.fleetName"
                    :value="item.fleetCode">
                  </el-option>
                </el-select>
              </div></template>
            </el-table-column>
            <el-table-column prop="vehicleNum" label="车数" align="center">
              <template slot-scope="scope"><div>
                <el-input placeholder="" maxlength="" size="mini" v-model.trim="scope.row.vehicleNum" style="width:100px;"></el-input>
              </div></template>
            </el-table-column>
            <el-table-column prop="" label="操作" align="center">
              <template slot-scope="scope"><div>
                <el-button  @click.native.prevent="delData(scope.$index, scope.row)" type="text" size="small">删除</el-button>
              </div></template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div  style="width:130px;margin:15px auto;">
         <el-button type="primary" @click="submitForm()" size='mini'>保存</el-button>
        <el-button @click="closeClick" size='mini'>取消</el-button>
      </div>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <div>
      <el-dialog
        :title="title"
        :visible.sync="detailsMark"
        :close-on-click-modal="false"
        width="60%"
        center
        :before-close="handleClose"
      >
      <div v-loading="detailsLoading">
        <div class="addressBox">
          <h4 class="title">
            <span>
              <i class="fa fa-envelope iconFont" aria-hidden="true"></i
              >申请信息
            </span>
          </h4>
          <hr />
          <div class="tongJi">
            <div>
              <span>用车时间：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.apply_start_time | dateFormat}} 至 {{detailsFrom.tVehicleapplyInfo.apply_end_time | dateFormat}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>用车单位：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.department_name}} - {{detailsFrom.tVehicleapplyInfo.subsidiary_department_name}}</span>
            </div>
          </div>
          <div class="tongJi">
            <div>
              <span>车型：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.vhc_type_name}} - {{detailsFrom.tVehicleapplyInfo.tonnage_model}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>车数：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.vhc_num}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>单价：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.unit_price + '/' + detailsFrom.tVehicleapplyInfo.pricing_method}}</span>
            </div>
          </div>
          <div class="tongJi">
            <div>
              <span>工作类型：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.work_type_name}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>工作内容：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.work_content}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>工作地点：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.vhcapply_address}}</span>
            </div>
          </div>
          <div class="tongJi">
            <div>
              <span>用车人：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.apply_user}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>联系电话：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.user_mobile}}</span>
            </div>
          </div>
        </div>

        <div class="addressBox">
          <h4 class="title">
            <span>
              <i class="fa fa-bars iconFont" aria-hidden="true"></i
              >分配信息
            </span>
          </h4>
          <hr />
          <div class="tongJi">
            <el-table
              :data="detailsFrom.detailsTabLias"
              ref=""
              border
              bordersize="mini"
              style="width: 100%; margin-top: 10px"
              center
              :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
              :header-row-style="{ height: '45px' }"
              :row-style="{ height: '35px' }"
              highlight-current-row
            >
              <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
              <el-table-column prop="fleetName" label="车队" align="center"></el-table-column>
              <el-table-column prop="" label="车型" align="center">
                <template ><div>
                  <span>{{detailsFrom.tVehicleapplyInfo.vhc_type_name}} - {{detailsFrom.tVehicleapplyInfo.tonnage_model}}</span>
                </div></template>
              </el-table-column>
              <el-table-column prop="vehicleNum" label="分配车数" align="center"></el-table-column>
              <el-table-column prop="createTime" label="分配时间" align="center">
                <template slot-scope="scope"><div>
                  <span>{{scope.row.createTime | dateFormat}}</span>
                </div></template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="addressBox">
          <h4 class="title">
            <span>
              <i class="fa fa-bars iconFont" aria-hidden="true"></i
              >出车信息
            </span>
          </h4>
          <hr />
          <div class="tongJi">
            <el-table
              :data="detailsFrom.outCar"
              ref=""
              border
              bordersize="mini"
              style="width: 100%; margin-top: 10px"
              center
              :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
              :header-row-style="{ height: '45px' }"
              :row-style="{ height: '35px' }"
              highlight-current-row
            >
              <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
              <el-table-column prop="customerName" label="操作" width="120" align="center" >
                <template slot-scope="scope"><div>
                  <!-- 只有已完成显示历史轨迹 1已派车 2工作中 3已完成-->
                  <el-button  type="text" size="small" btnCode="00MP003B006" v-if="scope.row.task_status != '3' && btnFlg[5]">实时位置</el-button>
                  <el-button  type="text" size="small" btnCode="00MP003B007" v-if="scope.row.task_status == '3' && btnFlg[6]" @click="handleHistoryClick(scope.row)">历史轨迹</el-button>
                </div></template>
              </el-table-column>
              <el-table-column prop="task_no" label="作业单号" align="center"></el-table-column>
              <el-table-column prop="task_status_name" label="状态" align="center"></el-table-column>
              <el-table-column prop="vehicle_no" label="车号" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="fleet_name" label="车队" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="driver_name" label="司机" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="driver_mobile" label="司机电话" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="" label="派车时间" align="center" :formatter="formatterRowEmpty">
                <template slot-scope="scope"><div>
                  <span>{{scope.row.create_time | dateFormat}}</span>
                </div></template>
              </el-table-column>
              <el-table-column prop="actual_work_duration" label="工作量" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="actual_start_time" label="工作开始时间" align="center" :formatter="formatterRowEmpty">
                <template slot-scope="scope"><div>
                  <span>{{scope.row.actual_start_time | dateFormat}}</span>
                </div></template>
              </el-table-column>
              <el-table-column prop="actual_end_time" label="工作结束时间" align="center" :formatter="formatterRowEmpty">
                <template slot-scope="scope"><div>
                  <span>{{scope.row.actual_end_time | dateFormat}}</span>
                </div></template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div style="width:90px;margin:15px auto;">
        <el-button type="primary" @click="detailsMark = false">关闭</el-button>
      </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  vheTypeList, // 车型下拉框
  applyList, // 查询列表
  getAllOrgUserTreeData, // 用车单位下拉框
  getDictionaryList,
  getVehicleTypeSelect, // 申请车型
  getAvailableFleetCarCount, // 分配/修改页面-可用车数列表
  forManager, // 分配/修改页面-用车申请已分配的车队信息
  fleetDistribution, // 分配/修改保存
  deleteFleetDistribution, // 分配/修改-删除
  vhcApplyDetail // 详情
} from '@/api/zhbPlantVehicles.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00MP003B001',
        '00MP003B002',
        '00MP003B003',
        '00MP003B004',
        '00MP003B005',
        '00MP003B006',
        '00MP003B007'
      ],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      },
      // 工作类型
      jobTypeOptions: [],
      // 车型
      carTypeOptions: [],
      statusOptions: [
        {
          showName: '已申请',
          itemNo: '1'
        },
        {
          showName: '已分配',
          itemNo: '2'
        },
        {
          showName: '已过期',
          itemNo: '3'
        },
        {
          showName: '已撤销',
          itemNo: '4'
        }
      ],
      tableList: [],
      tabLoading: false,
      // 新增/修改
      addAndChangeMark: false,
      addAndChangeLoading: false,
      addAndChangeFrom: {
        addAndChangeFromTabList: [],
        fleetTabList: [
          {
            fleetCode: '',
            vehicleNum: ''
          }
        ],
        fleetList: []
      },
      carUnitOptions: [],
      // 详情
      detailsMark: false,
      detailsFrom: {
        tVehicleapplyInfo: {},
        detailsTabLias: [],
        outCar: []
      },
      detailsLoading: false,
      fleetOptions: [],
      test: {},
      carAreaOptions: [],
      // 分配/修改
      rowId: '',
      tonnageModelId: '',
      vhcTypeId: '',
      applyId: '',
      isAdd: false,
      fleetDisabled: false,
      carAllNumber: '',
      keYongCar: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/vehicleController/applyCar')
    this.getSeatchData(this.searchFrom)
    // this.getVheTypeList()
    this.getAllOrgUserTreeData()
    this.getDictionaryList()
    this.getVehicleTypeSelect()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 150 + 'px'
  },
  methods: {
    // 时间格式化
    timeStamp (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    // 年月日
    timeStamp2 (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log("time:" + JSON.stringify(now));
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 数组求和
    sum (arr) {
      // eslint-disable-next-line no-eval
      return eval(arr.join('+'))
    },
    // 创建时间
    getToDay () {
      if (this.searchFrom.startDate == '' || this.searchFrom.endDate == '') {
        this.searchFrom.startDate = ''
        this.searchFrom.endDate = ''
      } else {
        this.searchFrom.startDate = this.timeStamp(this.searchFrom.startDate)
        this.searchFrom.endDate = this.timeStamp(this.searchFrom.endDate)
      }
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      applyList(this.searchFrom)
        .then((res) => {
          this.tabLoading = false
          this.tableList = res.list
          this.total = res.total
        })
        .catch((err) => {
          this.tabLoading = false
          // console.log(err.message)
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      this.getToDay()
      this.getSeatchData()
    },
    // 点击重置
    chongZhiClick () {
      this.getToDay()
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      }
      this.getSeatchData()
    },
    // 每页条数
    handleSizeChange (val) {
      this.getToDay()
      this.searchFrom.pageSize = val
      this.getSeatchData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.getToDay()
      this.searchFrom.pageNo = val
      this.getSeatchData()
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      // this.$refs.tableList.toggleRowSelection(row)
      // this.changeData = row
    },
    handleTabCurrentChange (val) {
      // this.currentRow = val
    },
    // 验证重复元素，有重复返回true；否则返回false
    isRepeat (arr) {
      var hash = {}
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true
      }
      return false
    },
    // 点击修改
    changeDataClick (row) {
      this.addAndChangeFrom.addAndChangeFromTabList = []
      this.addAndChangeFrom.fleetTabList = []
      this.addAndChangeMark = true
      this.title = '修改'
      this.isAdd = false
      this.rowId = row.id
      this.tonnageModelId = row.tonnageModelId
      this.vhcTypeId = row.vhcTypeId
      this.carAllNumber = row.vhcNum
      this.getAvailableFleetCarCount()
      this.getForManager()
    },
    // 点击分配
    distributionClick (row) {
      this.addAndChangeFrom.addAndChangeFromTabList = []
      this.addAndChangeFrom.fleetTabList = []
      this.addAndChangeMark = true
      this.title = '分配'
      this.isAdd = true
      this.rowId = row.id
      this.tonnageModelId = row.tonnageModelId
      this.vhcTypeId = row.vhcTypeId
      this.carAllNumber = row.vhcNum
      this.getAvailableFleetCarCount()
      this.getForManager()
    },
    getAvailableFleetCarCount () {
      this.addAndChangeLoading = true
      getAvailableFleetCarCount({
        id: this.rowId, // 用车申请的id
        tonnageModelId: this.tonnageModelId, // 机型/吨位的id
        vhcTypeId: this.vhcTypeId // 车型id,
      }).then((res) => {
        this.keYongCar = []
        this.addAndChangeLoading = false
        this.addAndChangeFrom.addAndChangeFromTabList = res
        this.addAndChangeFrom.addAndChangeFromTabList.forEach((item, index) => {
          this.keYongCar.push(item.count)
        })
        this.fleetOptions = res
      }).catch((err) => {
        this.addAndChangeLoading = false
        this.$message.error(err.message)
      })
    },
    getForManager () {
      this.addAndChangeLoading = true
      forManager(this.rowId).then((res) => {
        this.addAndChangeLoading = false
        if (res != null || res != undefined || res != []) {
          this.addAndChangeFrom.fleetTabList = res
        } else {
          this.addAndChangeFrom.fleetTabList = []
        }
        if (this.addAndChangeFrom.fleetTabList.length != 0) {
          this.addAndChangeFrom.fleetTabList.forEach((item, index) => {
            if (item.dispatcherCount > 0) {
              item.fleetDisabled = true
            } else {
              item.fleetDisabled = false
            }
          })
        } else {
          // this.fleetDisabled = false
        }
      }).catch((err) => {
        this.addAndChangeLoading = false
        this.$message.error(err.message)
      })
    },
    // 点击详情
    detailsClick (row) {
      this.detailsMark = true
      this.title = '详情'
      this.detailsLoading = true
      vhcApplyDetail({
        id: row.id
      })
        .then(res => {
          this.detailsLoading = false
          this.detailsFrom = res
          if (res.tVehicleapplyInfo != null || res.tVehicleapplyInfo != undefined) {
            this.detailsFrom.tVehicleapplyInfo = res.tVehicleapplyInfo
          }
          if (res.tFleetDistributionList.length != 0) {
            this.detailsFrom.detailsTabLias = res.tFleetDistributionList
          } else {
            this.detailsFrom.detailsTabLias = []
          }
          if (res.tVheicleTaskList.length != 0) {
            this.detailsFrom.outCar = res.tVheicleTaskList
          } else {
            this.detailsFrom.outCar = []
          }
        })
        .catch(err => {
          this.detailsLoading = false
          this.$message.error(err.message)
        })
    },
    // 点击分配添加
    addFleetTab () {
      var list = {
        fleetCode: '',
        vehicleNum: ''
      }
      this.addAndChangeFrom.fleetTabList.push(list)
      // this.fleetDisabled = false
      this.addAndChangeFrom.fleetTabList.forEach((item, index) => {
        if (item.fleetCode != '') {
          this.fleetDisabled = true
        } else {
          this.fleetDisabled = false
        }
      })
    },
    // 删除表格行
    delData (index, rows) {
      // this.addAndChangeFrom.fleetTabList.splice(index, 1)
      // console.log(rows.dispatcherCount)
      if (rows.dispatcherCount != undefined) {
        // if (rows.dispatcherCount > '0') {
        deleteFleetDistribution(rows.id).then((res) => {
          this.$message.success('删除成功')
          this.getForManager()
        }).catch((err) => {
          this.$message.error(err.message)
        })
        // } else {
        //   this.$message.error('已派车的数据不能删除')
        // }
      } else {
        this.addAndChangeFrom.fleetTabList.splice(index, 1)
      }
    },
    // 点击保存
    submitForm () {
      if (this.isAdd) {
        this.addAndChangeFrom.fleetList = []
        let fleetTabArray = []
        let fleetArr = []
        let carNum = []
        this.addAndChangeFrom.fleetTabList.forEach((item, index) => {
          const obj = {
            fleetCode: item.fleetCode, // 车队code
            vehicleNum: item.vehicleNum // 车数
          }
          fleetTabArray.push(obj)
        })
        this.addAndChangeFrom.fleetList = fleetTabArray
        for (let index = 0; index < fleetTabArray.length; index++) {
          fleetArr.push(fleetTabArray[index].fleetCode)
          carNum.push(fleetTabArray[index].vehicleNum)
        }
        // if (this.isRepeat(fleetArr) == true) {
        //   this.$message.error('所选车队不能重复！')
        // } else {
        //   this.addAndChangeLoading = true
        //   fleetDistribution(fleetTabArray, this.rowId).then((res) => {
        //     this.addAndChangeLoading = false
        //     this.addAndChangeMark = false
        //     this.$message.success('分配成功！')
        //     this.getSeatchData()
        //   }).catch((err) => {
        //     this.addAndChangeLoading = false
        //     this.$message.error(err.message)
        //   })
        // }
        if (this.isRepeat(fleetArr) == true) {
          this.$message.error('所选车队不能重复！')
        } else if (this.sum(carNum) > this.carAllNumber) {
          this.$message.error('所输入的车数不能大于申请车数！')
        } else if (this.sum(carNum) > this.sum(this.keYongCar)) {
          this.$message.error('所输入的车数不能大于可用车数！')
        } else {
          this.addAndChangeLoading = true
          fleetDistribution(fleetTabArray, this.rowId)
            .then((res) => {
              this.addAndChangeLoading = false
              this.addAndChangeMark = false
              this.$message.success('分配成功！')
              this.getSeatchData()
            })
            .catch((err) => {
              this.addAndChangeLoading = false
              this.$message.error(err.message)
            })
        }
      } else {
        this.addAndChangeFrom.fleetList = []
        let fleetTabArray = []
        let fleetArr = []
        let carNum = []
        this.addAndChangeFrom.fleetTabList.forEach((item, index) => {
          const obj = {
            id: item.id,
            fleetCode: item.fleetCode, // 车队code
            vehicleNum: item.vehicleNum // 车数
          }
          fleetTabArray.push(obj)
        })
        this.addAndChangeFrom.fleetList = fleetTabArray
        for (let index = 0; index < fleetTabArray.length; index++) {
          fleetArr.push(fleetTabArray[index].fleetCode)
          carNum.push(fleetTabArray[index].vehicleNum)
        }
        // console.log(this.sum(carNum), carNum)
        // console.log(this.sum(carNum), carNum)
        if (this.isRepeat(fleetArr) == true) {
          this.$message.error('所选车队不能重复！')
        } else if (this.sum(carNum) > this.carAllNumber) {
          this.$message.error('所输入的车数不能大于申请车数！')
        } else if (this.sum(carNum) > this.sum(this.keYongCar)) {
          this.$message.error('所输入的车数不能大于可用车数！')
        } else {
          this.addAndChangeLoading = true
          fleetDistribution(fleetTabArray, this.rowId)
            .then((res) => {
              this.addAndChangeLoading = false
              this.addAndChangeMark = false
              this.$message.success('修改成功！')
              this.getSeatchData()
            })
            .catch((err) => {
              this.addAndChangeLoading = false
              this.$message.error(err.message)
            })
        }
      }
    },
    // 点击取消
    closeClick () {
      this.addAndChangeMark = false
      this.addAndChangeFrom.addAndChangeFromTabList = []
      this.fleetOptions = []
    },
    closeDialog () {
      this.addAndChangeMark = false
      this.addAndChangeFrom.addAndChangeFromTabList = []
      this.fleetOptions = []
    },
    // 点击详情关闭
    handleClose (done) {
      this.detailsMark = false
    },
    // 获取车型下拉框
    // getVheTypeList(){
    //   vheTypeList().then(res => {
    //     this.carTypeOptions = res
    //   }).catch(err =>{
    //     this.$message.error(err.message)
    //   })
    // },
    // 获取用车单位下拉框
    getAllOrgUserTreeData () {
      getAllOrgUserTreeData().then((res) => {
        if (res) {
          this.test = JSON.parse(res)
          this.carUnitOptions = this.test[0].children
          console.log(this.test, 'this.test')
          console.log(this.test[0].children, 'this.test[0].children')
          for (let index = 0; index < this.carUnitOptions.length; index++) {
            let element = this.carUnitOptions[index]
            console.log(element, 'element')
            if (element.orgCode == this.addAndChangeFrom.carUnit) {
              this.carAreaOptions = element.children
              this.addAndChangeFrom.carUnitName = element.orgName
              return
            }
          }
        }
      }).catch((err) => {
        this.$message.error(err.message)
      })
    },
    // 用车单位值改变时
    carUnitChange (item) {
      this.searchFrom.subsidiaryDepartmentCode = ''
      if (item != null && item != undefined && item != '') {
        this.carAreaOptions = []
        for (let index = 0; index < this.carUnitOptions.length; index++) {
          let element = this.carUnitOptions[index]
          console.log(element, 'element')
          if (element.orgCode == item) {
            this.carAreaOptions = element.children
            return
          }
        }
      }
    },
    carAreaChange () {
      this.$forceUpdate() // 强制刷新
    },
    // 获取工作类型下拉框
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'work_type'
      }).then((res) => {
        this.jobTypeOptions = res
      }).catch((err) => {
        this.$message.error(err.message)
      })
    },
    // 申请车型、单价下拉框
    getVehicleTypeSelect () {
      getVehicleTypeSelect().then((res) => {
        this.carTypeOptions = res
      }).catch((err) => {
        this.$message.error(err.message)
      })
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}
.searchBox {
  margin-left: 25px;
}
.inpBox {
  margin: 10px 0 0 -30px;
}
.searchBtnBox {
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.tongJi {
  display: flex;
  margin-left: 10px;
  margin-bottom: 20px;
}
.tongJi_item {
  margin-right: 20px;
}
.tongJi_item span {
  color: red;
}
</style>
